import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { dateTimeToView, humanizedTimeRange } from "helpers/date";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { typeSpecificProps } from "helpers/reports";
import React from "react";
import { list as driversList } from "sources/books/drivers";
import CommonReport from "./commonReport";

export default class DriverWorkAndRestReport extends CommonReport {
    formatData = (data) => {
        const result = [];
        data.forEach((row) => {
            const { shifts, ...rest } = row;
            if (shifts.length > 0) {
                shifts.forEach((shiftRow) => {
                    result.push({ ...shiftRow, ...rest });
                });
            } else {
                result.push({ ...rest, isEmpty: true });
            }
        });
        return result;
    };

    extractColumns = () => {
        return [
            {
                Header: "ФИО водителя",
                accessor: "driverId",
                Filter: reportFilterWrapper((props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            ...defaultMultipleSelectProps,
                            url: driversList,
                            inputProps: { name: "driverId" },
                            propName: "user.fullName",
                            filterPropName: "user/fullName",
                            components: { ValueContainer },
                        }}
                    />
                )),
                filter: (rows, _id, filterValue) => {
                    if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                        return rows;
                    }
                    return rows.filter((row) => filterValue.value.includes(row.values.driverId));
                },
                Cell: (props) => {
                    const { subRows } = props.row;
                    return subRows[0].original.driverFullName;
                },
                IsGrouped: (props) => {
                    const { leafRows } = props.row;
                    return props.isGrouped && !leafRows[0].original.isEmpty;
                },
            },
            {
                Header: "Машина",
                accessor: "carNumber",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
                Aggregated: () => "",
            },
            {
                Header: "Логист",
                accessor: "carLogistDisplayName",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
                Aggregated: () => "",
            },
            {
                Header: "Рабочее время",
                accessor: "workTime",
                ...typeSpecificProps({ clrType: "timespan" }),
                Cell: ({ value }) => humanizedTimeRange(value),
                Aggregated: (props) => {
                    const { subRows } = props.row;
                    return humanizedTimeRange(subRows[0].original.averageWorkTime);
                },
                Footer: () =>
                    this.footerVal({
                        propertyName: "averageWorkTime",
                        aggregateType: true,
                        clrType: "timespan",
                    }),
            },
            {
                Header: "Начало рабочего времени",
                accessor: "workStartedAt",
                ...typeSpecificProps({ clrType: "datetimeoffset" }),
                Cell: ({ value }) => dateTimeToView(value),
                Aggregated: () => "",
            },
            {
                Header: "Окончание рабочего времени",
                accessor: "workEndedAt",
                ...typeSpecificProps({ clrType: "datetimeoffset" }),
                Cell: ({ value }) => dateTimeToView(value),
                Aggregated: () => "",
            },
            {
                Header: "Время отдыха",
                accessor: "restTime",
                ...typeSpecificProps({ clrType: "timespan" }),
                Cell: ({ value }) => humanizedTimeRange(value),
                Aggregated: (props) => {
                    const { subRows } = props.row;
                    return humanizedTimeRange(subRows[0].original.averageRestTime);
                },
                Footer: () =>
                    this.footerVal({
                        propertyName: "averageRestTime",
                        aggregateType: true,
                        clrType: "timespan",
                    }),
            },
            {
                Header: "Начало отдыха",
                accessor: "restStartedAt",
                ...typeSpecificProps({ clrType: "datetimeoffset" }),
                Cell: ({ value }) => dateTimeToView(value),
                Aggregated: () => "",
            },
            {
                Header: "Окончание отдыха",
                accessor: "restEndedAt",
                ...typeSpecificProps({ clrType: "datetimeoffset" }),
                Cell: ({ value }) => dateTimeToView(value),
                Aggregated: () => "",
            },
            {
                Header: "Время перерыва",
                accessor: "breakTime",
                ...typeSpecificProps({ clrType: "timespan" }),
                Cell: ({ value }) => humanizedTimeRange(value),
                Aggregated: (props) => {
                    const { subRows } = props.row;
                    return humanizedTimeRange(subRows[0].original.averageBreakTime);
                },
                Footer: () =>
                    this.footerVal({
                        propertyName: "averageBreakTime",
                        aggregateType: true,
                        clrType: "timespan",
                    }),
            },
        ];
    };

    tableExtraProps = () => ({
        initialState: {
            groupBy: ["driverId"],
        },
        data: this.formatData(this.props.data.data),
    });
}
